module.exports = __webpack_public_path__ + "2a91fdc2028e4aeb074daeeead07236c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-side-burn-s.png
// module id = 2698
// module chunks = 0